// Этап 6, раздел 2 «Пользователи» (docs/PLAN.md) — карточка: ВСЯ история подписок (не только
// активные, в отличие от Mini App) + вся история платежей по ним.
import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { type AdminUserDetail, ApiError, fetchUserCard } from "../api/client";
import { PaymentRow } from "../components/PaymentRow";
import { SubscriptionCard } from "../components/SubscriptionCard";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU");
}

export function UserCardScreen() {
  const { userId } = useParams<{ userId: string }>();
  const [user, setUser] = useState<AdminUserDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(() => {
    if (!userId) {
      return;
    }
    setLoading(true);
    setError(null);
    fetchUserCard(Number(userId))
      .then(setUser)
      .catch((err) => {
        setError(err instanceof ApiError ? err.message : "Не удалось загрузить пользователя");
      })
      .finally(() => setLoading(false));
  }, [userId]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return (
    <div className="screen">
      <Link to="/users">← Назад к поиску</Link>

      {loading && <p>Загрузка…</p>}
      {error && <div className="error-text">{error}</div>}

      {user && (
        <>
          <h2 style={{ marginTop: 16 }}>
            {user.username ? `@${user.username}` : `ID ${user.telegram_id}`}
          </h2>
          <div className="card" style={{ marginBottom: 24 }}>
            <div>Telegram ID: {user.telegram_id}</div>
            <div>Роль: {user.role === "admin" ? "администратор" : "клиент"}</div>
            <div>Статус: {user.is_active ? "активен" : "заблокирован"}</div>
            <div>Зарегистрирован: {formatDate(user.created_at)}</div>
          </div>

          <h3>Подписки ({user.subscriptions.length})</h3>
          {user.subscriptions.length === 0 ? (
            <p className="card">Подписок нет.</p>
          ) : (
            user.subscriptions.map((sub) => (
              <SubscriptionCard key={sub.id} subscription={sub} onChanged={loadUser} />
            ))
          )}

          <h3 style={{ marginTop: 24 }}>Платежи ({user.payments.length})</h3>
          {user.payments.length === 0 ? (
            <p className="card">Платежей нет.</p>
          ) : (
            <div className="card" style={{ padding: 0, overflow: "hidden" }}>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Дата</th>
                    <th>Сумма</th>
                    <th>Тип</th>
                    <th>Статус</th>
                    <th>Провайдер</th>
                    <th>ID у провайдера</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {user.payments.map((payment) => (
                    <PaymentRow key={payment.id} payment={payment} onChanged={loadUser} />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
